import codeUtil from "@plannel/pages/utils/code-util";

const buckets = codeUtil.buckets;

const getPlanningRange = (from, to, bucketUnit) => {
  const planStartDate = new ZDate(from);
  const planEndDate = new ZDate(to);
  const endYear = planEndDate.getFullYear();
  const startYear = planStartDate.getFullYear();
  let horizon = 0;

  if (codeUtil.isWeekBucket(bucketUnit)) {
    const dateGap = (planEndDate - planStartDate) / (1000 * 60 * 60 * 24 * 7);
    horizon = dateGap.toFixed(0);
  } else if (bucketUnit === buckets.MONTH) {
    if (endYear === startYear) {
      horizon = planEndDate.getMonth() - planStartDate.getMonth();
    } else {
      const yearPlusEndMon = (endYear - startYear) * 12 + planEndDate.getMonth();
      horizon = yearPlusEndMon - planStartDate.getMonth();
    }
    horizon = horizon + 1;
  } else if (bucketUnit === buckets.QUARTER) {
    if (endYear === startYear) {
      horizon = planEndDate.getMonth() - planStartDate.getMonth();
      horizon = horizon / 3;
    } else {
      const yearPlusEndMon = (endYear - startYear) * 12 + planEndDate.getMonth();
      horizon = yearPlusEndMon - planStartDate.getMonth();
      horizon = horizon / 3;
    }
  } else {
    horizon = endYear - startYear;
  }
  return Number(horizon);
};

const dpConfigUtils = {
  getPlanningRange,
};

export default dpConfigUtils;
